import React from "react";
import { Info } from "lucide-react";
import { DISCLAIMER } from "@/config/branding";

// Short single-line footer used beneath reports, exports and advisory content.
export function DisclaimerFooter({ className = "" }) {
  return (
    <p data-testid="disclaimer-short" className={`text-xs text-[#A99F90] ${className}`}>
      {DISCLAIMER.short}
    </p>
  );
}

// Full legal disclaimer block.
export function Disclaimer({ variant = "full", className = "" }) {
  if (variant === "short") return <DisclaimerFooter className={className} />;
  return (
    <div data-testid="disclaimer-full" className={`flex gap-3 text-xs text-[#A99F90] border-t border-[#EAE0D2] pt-5 ${className}`}>
      <Info size={15} className="shrink-0 mt-0.5 text-[#C6A45C]" />
      <div className="leading-relaxed space-y-2 max-w-3xl">
        <p className="text-[#8A7F70] font-medium uppercase tracking-[0.12em] text-[11px]">{DISCLAIMER.heading}</p>
        {DISCLAIMER.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        <p className="text-[#8A7F70] font-medium pt-1">{DISCLAIMER.short}</p>
      </div>
    </div>
  );
}

export default Disclaimer;
